import { DownloadFile, enqueueSnackbar } from 'actions';

import {
	GetFailureDropdownsRequest,
	AddDropdownFieldRequest,
	RemoveDropdownFieldRequest
} from '../requests/FailuresRequest';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG = 'TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG';
export const TOGGLE_OPTIONS_FAILURES_TRACKER_FORM = 'TOGGLE_OPTIONS_FAILURES_TRACKER_FORM';
export const GET_FAILURES_DROPDOWNS = 'GET_FAILURES_DROPDOWNS';
export const ADD_DROPDOWN_FIELD = 'ADD_DROPDOWN_FIELD';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onToggleOptionsFailuresTrackerDialog = visible => ({
	type: TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG,
	visible
});

const onToggleOptionsFailuresTrackerForm = (visible, dropdownLabel, dropdownName, dropdownValue, dropdownId) => ({
	type: TOGGLE_OPTIONS_FAILURES_TRACKER_FORM,
	visible,
	dropdownLabel,
	dropdownName,
	dropdownValue,
	dropdownId
});

const onGetFailureDropdowns = (value) => ({
	type: GET_FAILURES_DROPDOWNS,
	dropdowns: value
});

const onAddDropdownField = value => ({
	type: ADD_DROPDOWN_FIELD,
	newDropdownField: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ToggleOptionsFailuresTrackerDialog = visible => dispatch => {
	dispatch(onToggleOptionsFailuresTrackerDialog(visible));
};

export const ToggleOptionsFailuresTrackerForm = (visible, dropdownLabel, dropdownName, dropdownValue, dropdownId) => dispatch => {
	dispatch(onToggleOptionsFailuresTrackerForm(visible, dropdownLabel, dropdownName, dropdownValue, dropdownId));
};

export const GetFailureDropdowns = (type) => async (dispatch) => {
	await GetFailureDropdownsRequest(type).then(response => {
		dispatch(onGetFailureDropdowns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddDropdownField = (userId, name, value, relations) => async dispatch => {
	await AddDropdownFieldRequest(userId, name, value, relations)
		.then(response => {
			dispatch(GetFailureDropdowns('all'));
			dispatch(onAddDropdownField(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const RemoveDropdownField = (userId, name, value, id, relations) => async dispatch => {
	await RemoveDropdownFieldRequest(userId, name, value, id, relations)
		.then(response => {
			dispatch(GetFailureDropdowns('all'));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};
